import { NavigationExtras } from '@angular/router';

import { Link, TrackingData } from '@ecm/router';

import { SubItemTypeEnum } from './subItemTypeEnum';

export class SubItemViewModel {
    public cid: string;
    public label: string;
    public type: SubItemTypeEnum;
    public trackingArea: string;
    public trackingName: string;
    public trackedPage?: string;
    public picto?: string;
    public pictoImage?: string;
    public gaugePercent?: number;
    public noExtraBalance?: string;
    public freeBies?: string;
    public consumption?: string;
    public totalData?: string;
    public detail?: string[];
    public detailLong?: string[];
    public link?: Link;
    public linkParam?: NavigationExtras;
    public alert?: boolean;
    public trackingData?: TrackingData;
    public bundleCode?: string;

    public constructor(init?: Partial<SubItemViewModel>) {
        // Not recommended, used for retro-compatibility
        Object.assign(this, init);
    }
}
